import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=e2d3dfe0&scoped=true&"
import script from "./userView.vue?vue&type=script&lang=js&"
export * from "./userView.vue?vue&type=script&lang=js&"
import style0 from "./userView.vue?vue&type=style&index=0&id=e2d3dfe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d3dfe0",
  null
  
)

component.options.__file = "userView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VProgressCircular,
})
